module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    staticClass: "modal-container",
    class: {
      'full': _vm.expanding === true
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h3', [_vm._v("\n        Facet Configuration\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [(_vm.expanding) ? _c('div', [_vm._v("\n        Full Facet Here - " + _vm._s(_vm.expanding) + "\n      ")]) : _c('div', [_c('vue-form-generator', {
    attrs: {
      "schema": _vm.schema,
      "model": _vm.model,
      "options": _vm.formOptions
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-footer text-right"
  }, [_c('button', {
    staticClass: "button is-light",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.close
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": "ban",
      "size": "medium"
    }
  })], 1), _vm._v(" "), _c('span', [_vm._v("\n              Cancel\n            ")])]), _vm._v(" "), _c('button', {
    staticClass: "button is-primary config-submit",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.submit($event)
      }
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": "check",
      "size": "med"
    }
  })], 1), _vm._v(" "), _c('span', [_vm._v("\n              Save\n            ")])])])], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-996d755e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Modal.vue
// module id = 79
// module chunks = 0